window.__tnt || (window.__tnt = {});

(function(w, d) {
    let sGiftId, sGiftToken = false;
    const oGiftArticle = d.querySelector('.tnt-gift-article');
    const sAssetUuid = d.body.dataset.assetUuid;
    const sAssetUrl = oGiftArticle.dataset.assetUrl;
    const sAssetType = oGiftArticle.dataset.assetType;
    const oGiftError = d.getElementById('gift-error');
    const oGiftCopy = d.getElementById('gift-copy-clip');
    const oGiftCopyLink = d.getElementById('tnt-gift-copy');
    const oGiftLimit = d.getElementById('gift-limit');
    const oGiftDesc = d.querySelector('#tnt-gift-menu .gift-desc');
    const oGiftOpts = d.querySelector('#tnt-gift-menu .gift-options');

    let giftLimitData = localStorage.getItem('tnt_gift_limit_data');
    let oGiftLimits = {};
    if (giftLimitData) {
        oGiftLimits = JSON.parse(giftLimitData);
    }

    async function tnt_getGiftToken() {
        if (sGiftToken) return sGiftToken;

        try {
            let oResp = await fetch(__tnt.scrubUrl('/tncms/subscription/giftarticle_generate/?asset_id='+sAssetUuid+'&userServiceID='+sGiftId));

            if (oResp.ok) {
                let sText = await oResp.text();
                sGiftToken = sText.split('=')[1].replace('"', '');
                return sGiftToken;

            } else {
                oGiftError.hidden = false;
                setTimeout(function() {
                    oGiftError.hidden = true;
                }, 3000);
                let expDate = new Date();
                expDate.setMonth(expDate.getMonth() + 1, 1);
                expDate.setHours(0, 0, 0, 0);
                oGiftLimits[__tnt.user.screenName] = expDate.getTime();
                localStorage.setItem('tnt_gift_limit_data', JSON.stringify(oGiftLimits));
                return false;
            }
        } catch(e) {
            console.error('Promise error:', e);
        }
    }

    function hasValidService() {
        if (__tnt.user.services) {
            const aGiftServiceIds = JSON.parse(oGiftArticle.dataset.giftServiceIds).map(String);
            const aUserServiceIds = __tnt.user.services.split(',').map(String);

            aUserServiceIds.forEach(function(id) {
                if (aGiftServiceIds.includes(id)) {
                    sGiftId = id;
                    return false;
                }
            });
        }
    }

    function showGiftButton() {
        hasValidService();
        if (sGiftId) {
            document.getElementById('tnt-gift-btn').hidden = false;
        }
        if (userGiftLimitExpires()) {
            oGiftLimit.hidden = false;
            oGiftDesc.hidden = true;
            oGiftOpts.hidden = true;
        }
    }

    function userGiftLimitExpires() {
        if (Object.keys(oGiftLimits).length === 0) return false;
        if (oGiftLimits[__tnt.user.screenName]) {
            return oGiftLimits[__tnt.user.screenName];
        }
        return false;
    }

    function giftCounterReset() {
        let giftLimitExpires = userGiftLimitExpires();
        if (giftLimitExpires) {
            let _d = new Date();
            if (_d.getTime() > parseInt(giftLimitExpires)) {
                delete oGiftLimits[__tnt.user.screenName];
                localStorage.setItem('tnt_gift_limit_data', JSON.stringify(oGiftLimits));
            }
        }
    }

    // Show gift button
    d.addEventListener('DOMContentLoaded', function() {
        giftCounterReset();
        showGiftButton();
    });
    w.addEventListener('tnt-user-status', function() {
        showGiftButton();
    });

    // Prevents dropdown from closing on click
    d.getElementById('tnt-gift-menu').addEventListener('click', function(e) {
        e.stopPropagation();
    });

    // Email link logic
    d.getElementById('tnt-gift-email').addEventListener('click', function(e) {
        tnt_getGiftToken().then(function(token) {
            if (token) {
                let sGiftUrl = encodeURIComponent(`${sAssetUrl}?gift=1&gift_token=${token}`);
                top.location.href = `mailto:?subject=Gift ${sAssetType} for you!&body=${sGiftUrl}`;
            }
        });
    });

    // Copy link logic
    d.getElementById('tnt-gift-copy').addEventListener('click', function(e) {
        let oGiftCopyIcon = oGiftCopyLink.querySelector('.tnt-link');
        let oGiftCopySpinner = oGiftCopyLink.querySelector('.tnt-spinner');

        oGiftCopyIcon.setAttribute('hidden', '');
        oGiftCopySpinner.removeAttribute('hidden');

        tnt_getGiftToken().then(function(token) {
            oGiftCopyIcon.removeAttribute('hidden');
            oGiftCopySpinner.setAttribute('hidden', '');
            if (token) {
                navigator.clipboard.writeText(`${sAssetUrl}?gift=1&gift_token=${token}`).then(function() {
                    oGiftCopy.hidden = false;
                    setTimeout(function() {
                        oGiftCopy.hidden = true;
                    }, 3000);
                }, function(e) {
                    console.error('Could not copy text: ', e);
                });
            }
        });
    });
})(window, document);